<template>
  <div class="policy_warp">
    <myHeader />
    <div class="policy_content">
      <h3>Privacy policy</h3>
      <div class="txt">
        <p>hecoos strictly complies with laws and regulations and the following privacy protection principles to provide
          you with more secure and reliable services:</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>I. information collected</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>hecoos collects only the information necessary to realize the functions of the product according to the
          principles of legality, legality and necessity.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>1.1 the information you voluntarily provide when using the hecoos service</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>The information you fill in when you register an account, the information you upload when you use the
          service, the information you submit when you go through hecoos customer service or attend hecoos events.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>Some services of hecoos may require you to provide specific personally sensitive information to implement
          specific functions. By voluntarily providing your personally sensitive information, you agree that hecoos will
          handle your personally sensitive information for the purposes and manner described in this policy. If you
          choose not to provide this information, you may not be able to use the specific functionality in the service
          properly.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>1.2 the information that hecoos gets when you use the service</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>Log information, device information, software information, IP address, service log information, communication
          log information, location information, other relevant information, other user Shared information contains your
          information.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>1.3 hecoos may obtain information that you generate or share when using third-party partner services.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>Please read carefully the user agreement or privacy policy of the third-party partner service.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>The purpose, sharing and disclosure of the information collected</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>2.1 use</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>hecoos strictly complies with the provisions of laws and regulations and agreements with users, and USES the
          information collected for the following purposes: providing services to you, meeting your personalized needs,
          product development and service optimization, safety assurance, recommending advertising, information and
          other information that you may be interested in, investigation, big data analysis and so on.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>2.2 share your personal information with third parties.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>The third party includes (affiliates, third-party service providers, contractors, agents, advertising
          partners, application developers, etc.) and the share is used for the following purposes: to provide you with
          hecoos services; Perform hecoos obligations under the hecoos service agreement or this policy and exercise
          hecoos rights; Maintain and improve hecoos services.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>2.3 disclosure of your personal information</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>hecoos may disclose your personal information for the following purposes: to comply with applicable laws and
          regulations and other relevant provisions; Comply with court judgments, orders or other legal procedures;
          Comply with the requirements of relevant government agencies or other legally authorized organizations; To
          implement the relevant service agreement or this policy and safeguard the public interest; Reasonable and
          necessary use to protect the personal and property safety or other legitimate rights and interests of hecoos
          and its affiliates, customers, other users or employees.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>You can manage your own information</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>If you find that hecoos violates the provisions of laws and administrative regulations or both parties agree
          to collect and use your personal information, you can ask hecoos to delete it. If you find that your personal
          information collected and stored by hecoos is wrong, you can also ask hecoos to correct it.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>In using the hecoos service, you can access, modify, and delete registration information and other personal
          information. The scope and manner will depend on the specific service you use.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>4. hecoos may send information to you</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>When you use hecoos' services, hecoos may send you an email, text message, information or push notification,
          or a notice related to the service.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>The place and time limit for storing information</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>5.1 location of information storage</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>hecoos complies with laws and regulations and stores the personal information of users collected in China.
        </p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>5.2 duration of information storage</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>In general, hecoos retains your personal information only for the shortest period of time necessary to
          achieve the purpose. However, in order to comply with laws and regulations, court decisions, administrative
          orders, and maintain the safety or legitimate rights and interests of customers or hecoos and other personal
          property, hecoos may change the storage time of personal information in accordance with legal requirements.
        </p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>When hecoos products or services cease to operate, hecoos will notify you in the form of push notifications,
          announcements and other forms, and delete or anonymously process your personal information within a reasonable
          period of time.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>Information security</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>hecoos will establish a special management system and use a variety of reasonable security protection
          measures to ensure the security of information. In case of personal information disclosure and other security
          incidents, hecoos will take necessary measures to prevent the expansion of security incidents and inform you
          in the form of push notifications and announcements.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>Seven, advertising,</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>hecoos may use your relevant information to provide advertising to you on relevant websites, applications and
          other channels.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>Protection of minors</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>hecoos attaches importance to the protection of minors' personal information. Under applicable laws and
          regulations, if you are a minor under the age of 18, you should obtain the consent of your parent or legal
          guardian before using hecoos' services.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>Ix. Scope of application</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>This policy applies to all hecoos services. But some services have specific privacy policies that will be
          more specific about how hecoos handles your information in the service. In the event of any inconsistency
          between this policy and the privacy policy for a particular service, please refer to that particular privacy
          policy.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>Contact hecoos</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>If you have any questions about this policy or other related matters, please send your questions to
          admin@enlightv.com or to the following address: 13th floor, building 6, huoying guofeng meitang comprehensive
          building, changping district, Beijing.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>hecoos will review the issue as soon as possible and reply within a reasonable period of time after verifying
          your user's identity.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>Xi. Changes</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>hecoos may amend this policy in due course. By continuing to use the hecoos service, you agree to be bound by
          the revised policy.</p>
        <p><br></p>
      </div>
    </div>
    <myFooter />
    <BackToTop />
  </div>
</template>
<script>
import myHeader from "@/components/en_pc/myHeader.vue";
import myFooter from "@/components/en_pc/myFooter.vue";
import BackToTop from "@/components/pc/BackToTop";

export default {
  components: { myHeader, myFooter, BackToTop },
  data() {
    return {};
  },
  methods: {},
  mounted() { },
};
</script>
<style lang="scss" scoped>
.policy_warp {
  background-color: #dedede;

  .policy_content {
    width: 1210px;
    margin: 0 auto;
    padding: 80px 0;

    h3 {
      font-family: '微软雅黑';
      font-size: 30px;
      margin-bottom: 30px;
    }

    p {
      font-family: '微软雅黑';
      font-size: 18px;
      line-height: 32px;
      color: #333;
    }
  }
}
</style>